import React from "react";

export default function Tooltip(props) {
    const { text, children, disabled } = props;

    const refTooltip = React.useRef(null);
    const refTooltipText = React.useRef(null);

    React.useEffect(() => {
        const domTooltip = refTooltip.current;

        if (domTooltip) {
            updatePosition();

            domTooltip.addEventListener("hover", updatePosition);

            return () => {
                domTooltip.removeEventListener("hover", updatePosition);
            };
        }
    }, [text, children, disabled]);

    if (!text) {
        return children;
    }

    function updatePosition() {
        const domTooltip = refTooltip.current;
        const domTooltipText = refTooltipText.current;

        const tbcr = domTooltip.getBoundingClientRect();
        const ttbcr = domTooltipText.getBoundingClientRect();

        domTooltipText.style.setProperty("left", `-${ttbcr.width / 2 - tbcr.width / 2}px`);
        domTooltipText.style.setProperty("top", `-${ttbcr.height + 15}px`);
    }

    return (
        <div ref={refTooltip} className={["tooltip", disabled ? "disabled" : ""].join(" ")}>
            <div ref={refTooltipText} className="tooltip-text">
                {text}
            </div>

            {children}
        </div>
    );
}
